/**
 * @generated SignedSource<<3743495c78b34111faad39a05dfd3e15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FirstBookingConfirmScreenQuery$variables = {
  contractId: string;
};
export type FirstBookingConfirmScreenQuery$data = {
  readonly contract: {
    readonly careReceiver: {
      readonly name: {
        readonly firstName: string;
        readonly lastName: string;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"FirstBookingConfirmForm_contract">;
  } | null;
};
export type FirstBookingConfirmScreenQuery = {
  variables: FirstBookingConfirmScreenQuery$variables;
  response: FirstBookingConfirmScreenQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contractId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contractId",
    "variableName": "contractId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "CareReceiver",
  "kind": "LinkedField",
  "name": "careReceiver",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Name",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FirstBookingConfirmScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contract",
        "kind": "LinkedField",
        "name": "contract",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FirstBookingConfirmForm_contract"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FirstBookingConfirmScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Contract",
        "kind": "LinkedField",
        "name": "contract",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "isFirstBooking",
                "value": true
              }
            ],
            "concreteType": "Booking",
            "kind": "LinkedField",
            "name": "firstBooking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bookingId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": "firstBooking(isFirstBooking:true)"
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a33d1783f26b125b3c00213567d889ea",
    "id": null,
    "metadata": {},
    "name": "FirstBookingConfirmScreenQuery",
    "operationKind": "query",
    "text": "query FirstBookingConfirmScreenQuery(\n  $contractId: ID!\n) {\n  contract(contractId: $contractId) {\n    careReceiver {\n      name {\n        firstName\n        lastName\n      }\n    }\n    ...FirstBookingConfirmForm_contract\n    id\n  }\n}\n\nfragment FirstBookingConfirmForm_contract on Contract {\n  firstBooking(isFirstBooking: true) {\n    bookingId\n    startDate\n    endDate\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5b375a2f74b69c90547fb88e64d0429f";

export default node;
